'use strict';

export default class ModelCtrl {
  static get UID() {
    return 'modelCtrl';
  }

  constructor($state, $stateParams, modelFac) {
    Object.assign(this, {$state, $stateParams, modelFac } );

    this.model = {};
    this.currentPage = parseInt($stateParams.pageNum, 10) || 1;

    modelFac.getModel($stateParams.modelId)
      .then((response) => {
        this.model = response.data.data;
      });
  }

  pagination(pageNumber) {
    let pn = parseInt(pageNumber, 10) || 1;
    this.$state.go('model', {pageNum, pn});
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/model/modelCtrl.js